import React from 'react';
import clsx from 'clsx';
import { PrimaryButton } from '@/components/buttons/PrimaryButton/PrimaryButton';
import IconReload from '@/assets/icons/icon-reload.svg?react';
import IconAlert from '@/assets/icons/icon-alert.svg?react';

interface PageNotFoundProps {
  className?: string;
  onRefresh?: () => void;
}

export const PageNotFound: React.FC<PageNotFoundProps> = ({ className = '', onRefresh }) => {
  return (
    <div
      className={clsx(
        'relative flex h-[100vh] w-full flex-col items-center overflow-hidden bg-neutral-800 px-4',
        className,
      )}
    >
      <div className="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center gap-10">
        <div className="flex flex-col items-center gap-4.5">
          <div className="flex flex-col items-center gap-4">
            <div className="flex w-full items-center justify-center gap-2">
              <IconAlert className="fill-coral-500 h-8 w-8" aria-hidden />
              <h1 className="text-neutral-0 flex h-8 items-center font-sans text-3xl leading-normal font-semibold">
                Oops, this page does not exist!
              </h1>
            </div>
          </div>
        </div>
        <PrimaryButton
          text="Refresh Page"
          icon={IconReload}
          size="md"
          state="default"
          onClick={onRefresh}
        />
      </div>
      <div className="mt-12 mb-6 w-full max-w-md text-center text-xs leading-none font-medium text-neutral-400">
        ©2010-2026 Leadpages (US), Inc., All Rights Reserved.
      </div>
    </div>
  );
};

export default PageNotFound;
